export default {
    delete_webhook_title: 'Delete Webhook',
    delete_webhook_confirm: 'Are you sure you want to delete this webhook?',
    delete_webhook_success: 'Webhook deleted successfully',
    delete_webhook_error: 'Failed to delete webhook',
};
